app.controller('popupDrugsDosageController', ['$scope', '$state', '$mdDialog', '$translate', 'objectHelper',
    'baseModel', 'applicationModel', 'visitModel', 'prescribedDrugs', 'prescribedDrugModel',
    function ($scope, $state, $mdDialog, $translate, objectHelper, baseModel, applicationModel, visitModel,
              prescribedDrugs, prescribedDrugModel) {

        function processDosageType(prescribedDrug, selectedDosagesObject, dosageType) {
            if(selectedDosagesObject[dosageType] && prescribedDrug.dosageTypes.indexOf(Enum.DOSAGE_TYPE[dosageType]) == -1) {
                prescribedDrug.dosageTypes.push(Enum.DOSAGE_TYPE[dosageType]);
            }
            if(!selectedDosagesObject[dosageType] && prescribedDrug.dosageTypes.indexOf(Enum.DOSAGE_TYPE[dosageType]) != -1) {
                prescribedDrug.dosageTypes.splice(prescribedDrug.dosageTypes.indexOf(Enum.DOSAGE_TYPE[dosageType]), 1);
            }
        }

        function processPrescribedDrugsDosages(prescribedDrug, dosagesObject, index) {
            Object.keys(Enum.DOSAGE_TYPE).forEach(function(dosageType) {
                processDosageType(prescribedDrug, dosagesObject[index], dosageType)
            });

            return prescribedDrug;
        }

        function loadPrescribedDrugsDosages(prescribedDrugs) {
            prescribedDrugs.forEach(function(prescribeDrug, index) {
                $scope.addNewDosageObject(index, prescribeDrug);
            })
        }

        function setData() {
            $scope.prescribedDrugs = prescribedDrugs;
            //loadPrescribedDrugsDosages($scope.prescribedDrugs);

            $scope.additionalNotes = false;

            $scope.forms = {
                drugsDosage: null
            };

            $scope.drugsDosages = {};

        }

        function setPermissions() {
        }

        function setListeners() {

        }

        function setActions() {
            $scope.save = function () {
                $scope.forms.drugsDosage.$setSubmitted();
                if($scope.forms.drugsDosage.$valid) {
                    $scope.prescribedDrugs.forEach(function(drug, index) {
                        processPrescribedDrugsDosages(drug, $scope.drugsDosages, index);
                    });
                    $mdDialog.hide($scope.prescribedDrugs);

                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.addNewDosageObject = function(value, drug) {
                if(!drug.dosageTypes) {
                    drug.dosageTypes = [];
                }
                $scope.drugsDosages[value] = {
                    MORNING: drug.dosageTypes.indexOf(Enum.DOSAGE_TYPE.MORNING) != -1,
                    AFTERNOON: drug.dosageTypes.indexOf(Enum.DOSAGE_TYPE.AFTERNOON) != -1,
                    EVENING: drug.dosageTypes.indexOf(Enum.DOSAGE_TYPE.EVENING) != -1,
                    additionalNotes: (drug.additionalNotes) ? true : false
                };

            };

            $scope.getDrugTitle = function(prescribedDrug) {
                var str = '';

                if(!prescribedDrug.drug) {
                    str += prescribedDrug.recipe;
                } else {
                    str += prescribedDrug.drug.name;
                    if(prescribedDrug.drug.strength) {
                        str += ', ';
                        str += prescribedDrug.drug.strength;
                    }
                    if(prescribedDrug.drug.package) {
                        str += ', ';
                        str += prescribedDrug.drug.package;
                    }
                }


                return str;
            }



        }

        function configureInterface() {

        }

        function initialize() {
            prescribedDrugs.forEach(function(prescribeDrug, index) {
                $scope.addNewDosageObject(index, prescribeDrug);
            });

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);